module.exports = __webpack_public_path__ + "img/item3.ce42c427.png";